import { useEffect, useEffectEvent, useRef } from 'react';

/**
 * Runs `onSignal` when a bump counter (`uiSignals`) holds a signal this screen
 * has not handled yet: at mount if one is already raised (as a plain effect
 * did), then on each new bump. ios-tab-bar — a kept-alive tab re-runs its
 * effects every time it is shown again; a plain effect would replay the last
 * signal on each return (Découvre jumped back to the newest card).
 */
export function useOnNewSignal(signal: number, onSignal: () => void) {
  const handled = useRef(0);
  const fire = useEffectEvent(onSignal);

  useEffect(() => {
    if (signal === handled.current) return;
    handled.current = signal;
    fire();
  }, [signal]);
}
